import component from './quickStart.vue'

export default component
